import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../context/SnackbarContext";
import UsersService from "@velocity-ehs/user-utils-module";
import { useQuery } from "@tanstack/react-query";
import EhsConfigService from "../services/EhsConfigService";
import {
  EHS_CONFIG_TYPES,
  EHS_LANGUAGES,
} from "../components/routeComponents/EhsConfiguration/NavHelpers";

function useGetEhsConfigurationTypes() {
  const { showSnackbar } = useSnackbarActionContext();

  const result = useQuery({
    queryKey: ["ehsConfigurationTypes"],
    queryFn: () =>
      EhsConfigService.getEhsConfigurationTypes({
        customerId: UsersService.customer.id,
      }),
    retry: false,
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
  });

  return {
    ...result,
    ehsConfigurationTypes: getConfigTypes(EHS_CONFIG_TYPES, result.data?.items),
    languageConfigurationTypes: getConfigTypes(
      EHS_LANGUAGES,
      result.data?.items
    ),
  };
}

function getConfigTypes(configTypes: any[], data?: any[]) {
  if (!data) return [];
  const idLookup = data.reduce((acc, item) => {
    acc[item.name] = item.id;
    return acc;
  }, {});

  return configTypes.reduce((result, type) => {
    if (idLookup[type.name]) {
      result.push({ ...type, id: idLookup[type.name] });
    }
    return result;
  }, []);
}

export { useGetEhsConfigurationTypes };
